import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';
import './SimplePage.css';

const ThankYouPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <>
        <title>Thank You — ThirdRail Avenue</title>
      </>
      <Navbar />
      <main id="main-content" className="simple-page">
        <div className="simple-page__glow" />
        <div className="simple-page__content tra-container">
          <div className="simple-page__check">✓</div>
          <h1>Message received</h1>
          <p>Thanks for reaching out. Our team will be in touch shortly.</p>
          <Button to="/" variant="primary" size="lg" arrow>Back to Home</Button>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ThankYouPage;
